import styled from "styled-components";

export const GroupFormsContainer = styled.div`
  margin: 20px auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  background-color: #e3e3e3;
  gap: 4px;
`;
export const EvaluationDataDiv = styled.div`
  margin: 0 auto 8px;
  padding: 2px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: ${({ flexDirection }) => (flexDirection ? flexDirection : "column")};
  background-color: #fff;
  border-radius: 5px;
`;
export const Column = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  background-color: ${({ background }) => background && background};
  overflow-x: ${({ overFlowX }) => overFlowX && overFlowX};
`;
export const Row = styled.div`
  width: 100%;
  display: flex;
  background-color: ${({ background }) => background && background};
  border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
`;
export const Box = styled.div`
  padding: ${({ padding }) => padding && padding};
  width: ${({ width }) => width && width};
  min-height: 40px;
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection && flexDirection};
  flex: ${({ width }) => (width ? "none" : "1")};
  align-items: center;
  justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : "center")};
  background-color: ${({ background }) => background && background};
  border-left: ${({ borderLeft }) => borderLeft && borderLeft};
  gap: ${({ gap }) => (gap ? gap : "8px")};
`;
export const Text = styled.p`
  width: ${({ width }) => width && width};
  font-size: 14px;
  font-weight: ${({ strong }) => (strong ? "600" : "400")};
  color: ${({ color }) => color && color};
  text-align: ${({ align }) => align && align};
`;
export const Separator = styled.div`
  width: 1px;
  height: 70%;
  background-color: ${({ background }) => background && background};
`;
